'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

var _themeVariants = require('@shopify/theme-variants');

var _themeVariants2 = _interopRequireDefault(_themeVariants);

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImageWrapper: '[data-product-image-wrapper]',
  productFeaturedImage: '[data-product-featured-image]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  productThumbs: '[data-product-single-thumbnail]',
  singleOptionSelector: '[data-single-option-selector]',
  notifyForm: '[data-notify-form]',
  variantText: '[data-variant-name-text]',
  variantForm: '[data-variant-value]',
  variantLoad: '[data-current-variant]'
}; /**
    * Product Template Script
    * ------------------------------------------------------------------------------
    * A file that contains scripts highly couple code to the Product template.
    *
    * @namespace product
    */

var cssClasses = {
  activeThumbnail: 'active-thumbnail',
  hide: 'hide'
};

var keyboardKeys = {
  ENTER: 13
};

/**
 * Product section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {
    this.$container = (0, _jquery2.default)(this.container);
    this.namespace = '.' + this.id;
    // console.log(currentOptions);
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor

    if (!(0, _jquery2.default)(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse((0, _jquery2.default)(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.variants = new _themeVariants2.default(options);
    this.$featuredImage = (0, _jquery2.default)(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateImages.bind(this));
    }

    this.initImageSwitch();
  },
  initImageSwitch: function initImageSwitch() {
    var _this = this;

    var $productThumbs = (0, _jquery2.default)(selectors.productThumbs, this.$container);

    if (!$productThumbs.length) {
      return;
    }

    $productThumbs.on('click', function (evt) {
      evt.preventDefault();
      var imageId = (0, _jquery2.default)(evt.currentTarget).data('thumbnail-id');
      _this.switchImage(imageId);
      _this.setActiveThumbnail(imageId);
    }).on('keyup', this.handleImageFocus.bind(this));
  },
  handleImageFocus: function handleImageFocus(evt) {
    if (evt.keyCode !== keyboardKeys.ENTER) {
      return;
    }

    this.$featuredImage.filter(':visible').focus();
  },
  setActiveThumbnail: function setActiveThumbnail(imageId) {
    var newImageId = imageId;

    // If "imageId" is not defined in the function parameter, find it by the current product image
    if (typeof newImageId === 'undefined') {
      newImageId = (0, _jquery2.default)(selectors.productImageWrapper + ':not(\'.' + cssClasses.hide + '\')').data('image-id');
    }

    var $thumbnail = (0, _jquery2.default)(selectors.productThumbs + '[data-thumbnail-id=\'' + newImageId + '\']');

    (0, _jquery2.default)(selectors.productThumbs).removeClass(cssClasses.activeThumbnail).removeAttr('aria-current');

    $thumbnail.addClass(cssClasses.activeThumbnail);
    $thumbnail.attr('aria-current', true);
  },
  switchImage: function switchImage(imageId) {
    var $newImage = (0, _jquery2.default)(selectors.productImageWrapper + '[data-image-id=\'' + imageId + '\']', this.$container);
    var $otherImages = (0, _jquery2.default)(selectors.productImageWrapper + ':not([data-image-id=\'' + imageId + '\'])', this.$container);
    $newImage.removeClass(cssClasses.hide);
    $otherImages.addClass(cssClasses.hide);
  },


  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
  updateAddToCartState: function updateAddToCartState(evt) {
    var variant = evt.variant;
    var variantTitle = variant.title;
    var formValue = (0, _jquery2.default)(selectors.variantForm, this.$container);
    if (variant) {
      (0, _jquery2.default)(selectors.priceWrapper, this.$container).removeClass(cssClasses.hide);
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
      (0, _jquery2.default)(selectors.notifyForm, this.$container).removeClass(cssClasses.hide);
      return;
    }

    if (variant.available) {
      (0, _jquery2.default)(selectors.notifyForm, this.$container).addClass(cssClasses.hide);
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', false).removeClass(cssClasses.hide);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
    } else {
      (0, _jquery2.default)(selectors.variantForm, this.$container).val(formValue.val() + ' ' + variantTitle);
      (0, _jquery2.default)(selectors.variantText, this.$container).html(variantTitle);
      (0, _jquery2.default)(selectors.notifyForm, this.$container).removeClass(cssClasses.hide);
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true).addClass(cssClasses.hide);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
    }
  },
  updateImages: function updateImages(evt) {
    var variant = evt.variant;
    var imageId = variant.featured_image.id;

    this.switchImage(imageId);
    this.setActiveThumbnail(imageId);
  },


  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
  updateProductPrices: function updateProductPrices(evt) {
    var variant = evt.variant;
    var $comparePrice = (0, _jquery2.default)(selectors.comparePrice, this.$container);
    var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

    (0, _jquery2.default)(selectors.productPrice, this.$container).html((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat));

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html((0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat));
      $compareEls.removeClass(cssClasses.hide);
    } else {
      $comparePrice.html('');
      $compareEls.addClass(cssClasses.hide);
    }
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {
    this.$container.off(this.namespace);
  }
});

(0, _jquery2.default)(document).ready(function () {

  (0, _jquery2.default)('.images').slick({
    slidesToShow: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    centerMode: true,
    fade: true
  });
  (0, _jquery2.default)('#notify-me').click(function () {

    (0, _jquery2.default)('#notify-me-wrapper').fadeIn();

    return false;
  });
  var formValue = (0, _jquery2.default)(selectors.variantForm, this.$container);
  var variantTitle = (0, _jquery2.default)(selectors.variantLoad, this.$container).html();
  (0, _jquery2.default)(selectors.variantForm, this.$container).val(formValue.val() + ' ' + variantTitle);
});